import getPropertyPhotos from '../themes/default/helpers/getPropertyPhotos';

/**
 * @param {Property} property
 * @return {Object} Brytescore Listing
 */
const getBrytescoreListing = (property) => ({
  address: {
    streetAddress: property.getAddress() || 'Address Hidden',
    city: property.location.address.city,
    stateProvince: property.location.address.state_or_province,
    zipPostal: property.location.address.postal_code,
  },
  fullBaths: property.structure.bathrooms_total_integer,
  bedrooms: property.structure.bedrooms_total,
  halfBaths: property.structure.bathrooms_half,
  listingURL: window.location.href,
  mlsId: property.listing.listing_id,
  photoURL: getPropertyPhotos(property)
    .find((photo) => photo)?.media_url,
  price: property.listing.price.list_price,
  squareFeet: property.structure.living_area,
  subdivision: property.location.area.subdivision_name,

});

export default getBrytescoreListing;
